import { Component } from '@angular/core';
import { AnimationOptions } from "ngx-lottie";

@Component({
  selector: 'cosmos-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {

  public options: AnimationOptions = {
    path: '/assets/lottie/spinner.json',
  };
}
